module.exports = __webpack_public_path__ + "img/ic_expand.32bfd523.svg";